class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.initSwiper()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
      this.updateProgressBarDrawer();
      this.updateNumberItems();
      
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
        this.updateProgressBarDrawer();
        this.updateNumberItems();
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        // console.log("test 2");
        // console.log(this);
        // console.log(this.classList.contains('is-empty'));
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        // console.log(containerToTrapFocusOn);
        // console.log(focusElement);
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
      
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      this.initSwiper()
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      
    });
  }

  initSwiper() {
    if(document.querySelector(`[data-swiper-to-copy]`)){
      const swiperToCopy = document.querySelector(`[data-swiper-to-copy]`);
      document.querySelector(`[data-subheader]`).innerHTML = swiperToCopy.innerHTML;

      new Swiper('[data-subheader] .swiper', {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 2000
        },
        effect: 'coverflow'
      });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    // console.log(selector);
    // console.log(new DOMParser().parseFromString(html, 'text/html'));
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    
  }

  getSectionsToRender() {
    
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
  
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  
  setActiveElement(element) {
    this.activeElement = element;
  }

  updateNumberItems(){
    const qtySelectors = document.querySelectorAll(".card-drawer_content .quantity__input");
    const totals__subtotal = document.querySelector(".totals__subtotal span.total_products");
    const totals__subtotalWord = document.querySelector(".totals__subtotal span.total_product_word");
    
    let total = 0;

    qtySelectors.forEach(function(qtySelector) {
      // Obtenez la valeur de chaque input en utilisant "value"
      const value = parseInt(qtySelector.value);

      // Vérifiez si "value" est un nombre valide avant l'addition
      if (!isNaN(value)) {
        total += value;
      }
    });
    totals__subtotal.textContent = total;
    
    if (total > 1){
      totals__subtotalWord.textContent = "produits";
    } else {
      totals__subtotalWord.textContent = "produit";
      
    }
    this.updateStickyButton(total);
  }

  updateStickyButton(total){
    
    const stickyButtonCollection = document.querySelector(".sticky-button_container .button-collection");
    const stickyButtonCheckout = document.querySelector(".sticky-button_container .cart__checkout-button");
    
    if (total > 0){
      stickyButtonCheckout.classList.remove("display_none");
      stickyButtonCollection.classList.add("display_none");
    } else {
      stickyButtonCheckout.classList.add("display_none");
      stickyButtonCollection.classList.remove("display_none");
    }
  }

  updateProgressBarDrawer(){
    const progressBarContainer = document.querySelector(".progress-bar_container_drawer")
    const progressBarDrawer = document.querySelector(".progress-bar_icons .progress-bar_drawer");
    if(!progressBarContainer || !progressBarDrawer) return;
    const totalPrice = document.querySelector(".totals__subtotal-value");
    var supriseGap = document.querySelector("header").dataset.freeGift;
    var deliveryGap = document.querySelector("header").dataset.freeDelivery;
    // Récupérer le contenu texte de l'élément
    const content = totalPrice.textContent;
    // Extraire la partie numérique en supprimant les caractères non numériques
    const numericPart = content.replace(/[^0-9,-]/g, '');
    // Remplacer les virgules par des points (le format standard des nombres en JavaScript)
    const numericValue = numericPart.replace(',', '.');
    // Convertir la chaîne en un nombre à virgule flottante (float)
    const floatValue = parseFloat(numericValue);
    
    // Calculer le pourcentage de progression
    let progressBarDrawerWidth = deliveryGap;
    console.log("testing");
    // console.log(floatValue);
    // console.log(supriseGap);
    if (floatValue >= supriseGap) {
      progressBarDrawerWidth = 100; // Si le panier est de 20€ ou plus, la barre est à 100%
    } else {
      progressBarDrawerWidth = ((floatValue + parseFloat(deliveryGap)) * 100) / supriseGap;
    }
    // Mettre à jour la largeur de la barre de progression
    progressBarDrawer.style.width = `${progressBarDrawerWidth}%`;
    
    // Mettre à jour le texte indiquant le montant restant pour la livraison gratuite et la surprise
    
    let remainingPrice = "";
    let remainingPriceGift = "";
    const progressText = document.querySelector(".progress-bar_container_drawer p");
    const deliveryBackground = document.querySelector(".progress-bar_delivery");
    
    if (floatValue <= supriseGap) {
      remainingPrice = supriseGap - floatValue;
      deliveryBackground.classList.add("active");
      const messageStep1 = document.querySelector("header").dataset.firstMessage.replace('##left##', remainingPrice.toFixed(2));
      progressText.textContent = messageStep1;
    } else if (floatValue >= supriseGap){
      const messageStep2 = document.querySelector("header").dataset.secondMessage;
      progressText.textContent = messageStep2;
      progressText.style.fontWeight = "400";
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart__contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


